var map = {
	"./atv-Din.png": 7005,
	"./atv-Dinsdag.png": 8832,
	"./atv-Don.png": 7207,
	"./atv-Donderdag.png": 2444,
	"./atv-Maa.png": 407,
	"./atv-Maandag.png": 385,
	"./atv-Vrij.png": 2887,
	"./atv-Vrijdag.png": 4199,
	"./atv-Woe.png": 7259,
	"./atv-Woensdag.png": 9616,
	"./atv-Zat.png": 7610,
	"./atv-Zaterdag.png": 4250,
	"./atv-Zon.png": 8005,
	"./atv-Zondag.png": 8373,
	"./atv-overzicht.png": 880,
	"./atv-vannacht.png": 5245
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8321;